import { render, staticRenderFns } from "./XFilterAuxItems.vue?vue&type=template&id=61012036"
import script from "./XFilterAuxItems.vue?vue&type=script&lang=js"
export * from "./XFilterAuxItems.vue?vue&type=script&lang=js"
import style0 from "./XFilterAuxItems.vue?vue&type=style&index=0&id=61012036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports